const Effect = ({ x, y, minX, minY, maxX, maxY, effectType, reverse }) => kontra.sprite({
  x: x !== undefined ? x : randomBetween(minX - effectType.width / 2, maxX - effectType.width / 2),
  y: y !== undefined ? y : randomBetween(minY - effectType.height / 2, maxY - effectType.height / 2),
  frame: reverse ? effectType.frames : 0,
  frameTime: 0,
  finished: false,
  type: effectType,

  // update() {
  //   this.frame++
  //   if (this.frame > effectType.frames) {
  //     this.finished = true
  //   }
  // },

  render() {
    this.frameTime++
    if (this.frameTime > effectType.speed) {
      this.frame++
      if (this.frame > effectType.frames) {
        this.finished = true
      }
      this.frameTime = 0
    }

    this.context.drawImage(
      kontra.assets.images[effectType.image],
      this.frame * effectType.width, 0, effectType.width, effectType.height,
      this.x, this.y, effectType.width, effectType.height,
    )
  }
})

export default Effect